import api from '@/api/api';
import { TMarketCreationResponse } from '../marketCreation.types';
import { TUpdateMarketBody } from './updateMarket.types';
import { isWincore } from '@/features/betApprovals/pages/BetApprovals/tabs/Approvals';
import { getPrefixPath } from '@/common/utils';

const updateMarketURL = `/${getPrefixPath(
  isWincore
)}/trade-manager/market-creation/update-market`;

// Trade Manager - Update Market

export const mutateUpdateMarket = (body: TUpdateMarketBody) =>
  api
    .post<TMarketCreationResponse>(updateMarketURL, body)
    .then((res) => res.data);
